import { render, staticRenderFns } from "./ShiftForm.vue?vue&type=template&id=b9096008&scoped=true&"
import script from "./ShiftForm.js?vue&type=script&lang=js&"
export * from "./ShiftForm.js?vue&type=script&lang=js&"
import style0 from "./ShiftForm.scss?vue&type=style&index=0&id=b9096008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9096008",
  null
  
)

export default component.exports